export function tryFunctionOrLogError(f) {
    try {
        return f();
    }
    catch (e) {
        if (console.error) {
            console.error(e);
        }
    }
}
//# sourceMappingURL=errorHandling.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-client/util/errorHandling.js
// module id = 272
// module chunks = 9